<template>
  <div>
    <h1>{{ current }}</h1>
    <h1>{{ total }}</h1>
    <section class="modifier">
      <button @click="(current = 0), (total = 0), (selected = null)">
        AC
      </button>
    </section>
    <button
      v-for="operator in operators"
      :key="operator.id"
      @click="calculate(operator)"
    >
      {{ operator }}
    </button>
    <button @click="calculate()">=</button>
    <section>
      <button
        @click="current == 0 ? (current = String(digit)) : (current += digit)"
        v-for="digit in 10"
        :key="digit.id"
      >
        {{ digit }}
      </button>
      <button @click="current += '.'">.</button>
    </section>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      current: 0,
      total: 0,
      operators: ["+", "-", "*", "/"],
      selected: null
    };
  },
  computed: {
    // get only, just need a function
    result: function() {
      return eval(this.total + this.selected + Number(this.current));
    }
  },
  methods: {
    updateTotal: function() {
      this.total = this.result;
    },

    calculate: function(symbol = null) {
      this.updateTotal();
      this.selected = symbol;
      this.current = 0;
    }
  }
};
</script>

<style></style>
